import { Card, CardContent } from '@/components/ui/card'
import config from '../../../../../config'
import { useTranslation } from '@/hooks/useTranslation'

export const FramerSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="framer" className="mb-16">
			<h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
				{t('docs.framer.title')}
			</h2>
			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardContent className="pt-6">
					<ol className="list-decimal pl-5 space-y-3 text-gray-700 dark:text-gray-300">
						<li>{t('docs.framer.step1')}</li>
						<li>
							{t('docs.framer.step2.prefix')}{' '}
							<strong>{t('docs.framer.step2.iconName')}</strong>{' '}
							{t('docs.framer.step2.suffix')}
						</li>
						<li>
							{t('docs.framer.step3.prefix')}{' '}
							<strong>{t('docs.framer.step3.tabName')}</strong>{' '}
							{t('docs.framer.step3.suffix')}
						</li>
						<li>
							{t('docs.framer.step4.prefix')}{' '}
							<strong>{t('docs.framer.step4.sectionName')}</strong>{' '}
							{t('docs.framer.step4.suffix')}
						</li>
						<li>
							{t('docs.framer.step5.prefix')}{' '}
							<strong>{t('docs.framer.step5.optionName')}</strong>
						</li>
						<li>
							{t('docs.framer.step6.prefix')}{' '}
							{config.appName}{' '}
							{t('docs.framer.step6.suffix')}
						</li>
						<li>
							{t('docs.framer.step7.prefix')}{' '}
							<strong>{t('docs.framer.step7.button')}</strong>
						</li>
						<li>{t('docs.framer.step8')}</li>
					</ol>
				</CardContent>
			</Card>
		</section>
	)
}